// @ts-nocheck
import { initialState } from './reducer';
import { STORE_PREFIX } from './constants';

const planogramDetailsSelector = state => state[STORE_PREFIX] || initialState;

export const getIsStoresEnabled = (state) => planogramDetailsSelector(state)?.isStoresEnabled


